import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import {i18nReducer} from 'react-redux-i18n';
import commonReducer from '../common/common.reducer';
import loginReducer from '../login/login.reducer';
import homeReducer from '../home/home.reducer';
import attentionsReducer from '../attentions/attentions.reducer';
// [ROOT REDUCER] IMPORT REDUCER


const createRootReducer = (history) => combineReducers({
    i18n: i18nReducer,
    router: connectRouter(history),
    common: commonReducer,
    login: loginReducer,
    home: homeReducer,
    attentions: attentionsReducer,
    // [ROOT REDUCER] ADD REDUCER
});

export default createRootReducer;
